@if (src) {
  <img
    class="avatar__picture"
    [src]="src"
    [alt]="alt"
    >
} @else {
  <app-icon class="avatar__icon" [class.avatar__icon--white]="isWhite" size="inherit" verticalSize="inherit" svgPath="user-profile.svg"></app-icon>
}
